import type { Cruz } from '@cruz-com/lookup'
import slugify from 'slugify'

export const UserId = (user: Cruz.User) => {
  if (!user?._id) {
    return '-'
  }
  const slugName = slugify(`${user.first_name} ${user.last_name}`, { lower: true })
  return (
    <a href={`${process.env.NEXT_PUBLIC_CRUZ_WEB_URL}/user/${slugName}/${user._id.toString()}/vehicles`} className='link' target='_blank'>
      {user._id.toString()}
    </a>
  )
}
